
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeGalpon: null,
    galpones: [],
    isLoadingGalpon: false,
    totalGalpon: 0,

    
});






export const useGalponesStore = create()(
    devtools(
        storeApi
    )
)
